// extracted by mini-css-extract-plugin
export default {"progress":"FileUploadProgress_progress__O64t1","back":"FileUploadProgress_back__0a089","fornt":"FileUploadProgress_fornt__AXW7W","front":"FileUploadProgress_front__nydod"};